import { render } from "./PastBooking.vue?vue&type=template&id=c84136dc"
import script from "./PastBooking.vue?vue&type=script&lang=js"
export * from "./PastBooking.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__